import styled from "@emotion/styled";
import theme from "../../styles/theme";
import { css } from "@emotion/css";
import { GatsbyImage } from "gatsby-plugin-image";

interface IHeaderProps {
  isDarkMode: boolean;
  transitionPercent: number;
}

export const ContentCarouselBase = styled.section`
  margin: ${theme.sliceSpacing} auto;
  overflow-x: hidden;
`;

export const Header = styled.header<IHeaderProps>`
  ${(props) =>
    props.isDarkMode && props.transitionPercent > 0.5
      ? `
    h2 {
      color: ${theme.colors.white};
    }
  `
      : ``}
`;

export const Slide = styled.div`
  padding: ${theme.spacing[2]};
  width: calc(150px + ${theme.spacing[8]}) !important;

  ${theme.largerThan.lg} {
    width: calc(200px + ${theme.spacing[8]}) !important;
  }
`;

export const Card = styled.a`
  padding: ${theme.spacing[4]};
  background-color: ${theme.colors.darkBlues[5]};
  border-radius: ${theme.borderRadius};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  transition: all 0.2s ease-out;

  &:hover {
    background-color: ${theme.colors.blues[10]};
    transform: scale(1.1);
  }

  ${theme.largerThan.lg} {
    padding: ${theme.spacing[8]};
  }
`;

export const CardImage = styled(GatsbyImage)`
  max-width: 100px;
  max-height: 100px;
`;

export const CardTitle = styled.h6`
  font-size: ${theme.fontSizes[1]};
  font-weight: ${theme.fontWeights.semibold};
`;

export const SliderNav = styled.nav`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${theme.spacing[4]};
`;

export const SliderArrow = styled.div`
  height: 32px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 4;
  cursor: pointer;
  background-color: ${theme.colors.darkBlues[5]};
  border-radius: 100%;
  transition: all 0.1s ease-out;

  i {
    font-size: ${theme.fontSizes[3]};
  }

  &:hover {
    background-color: ${theme.colors.blues[100]};
    color: ${theme.colors.white};
  }
`;

export const SliderClass = css`
  margin-bottom: ${theme.spacing[8]};
  transform: translateX(-${theme.spacing[2]});

  .slick-list {
    overflow: visible;
  }
`;
